import { Loop, LoopReducer } from "redux-loop";
import { Action } from "../actions";
import { ActionTypes } from "../actions/mapDownload";
import { RiskClassLevel } from "../models";

export type MapDownloadState = {
  readonly header: string;
  readonly description: string;
  readonly definition: string;
  readonly riskLevel: RiskClassLevel | null;
  readonly dataUrl: string;
};

export const initialState: MapDownloadState = {
  header: "",
  description: "",
  definition: "",
  riskLevel: null,
  dataUrl: ""
};

const mapDownloadReducer: LoopReducer<MapDownloadState, Action> = (
  state: MapDownloadState = initialState,
  action: Action
): MapDownloadState | Loop<MapDownloadState, Action> => {
  switch (action.type) {
    case ActionTypes.MAP_DOWNLOAD_HEADER_SET:
      return {
        ...state,
        header: action.header
      };
    case ActionTypes.MAP_DOWNLOAD_DESC_SET:
      return {
        ...state,
        description: action.description
      };
    case ActionTypes.MAP_DOWNLOAD_DEF_SET:
      return {
        ...state,
        definition: action.definition
      };
    case ActionTypes.MAP_DOWNLOAD_LEVEL_SET:
      return {
        ...state,
        riskLevel: action.riskLevel
      };
    case ActionTypes.MAP_DOWNLOAD_DATA_URL_SET:
      return {
        ...state,
        dataUrl: action.dataUrl
      };
    default:
      return state;
  }
};

export default mapDownloadReducer;
